import { ProjectParameterConfigurationBase } from './base/project-parameter-configuration-base';

export class ProjectParameterConfiguration extends ProjectParameterConfigurationBase { }